<template>
  <div id="Blank-Page">
    <v-container fluid>
      <v-layout>
        <v-flex xs12>
          <h1>ยืนยันใบนำส่ง</h1>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <!-- append-icon="filter_list" -->
          <v-text-field
            prepend-inner-icon="search"
            single-line
            label="ค้นหา"
            v-model="filter.searchText"
            @keyup.enter="searchFilter()"
          >
            <template v-slot:append>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on" icon>
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text>
                    <v-container>
                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader>Date</v-subheader>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field
                            single-line
                            @click.stop
                            slot="activator"
                            v-model="filter.date"
                            type="date"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader>Messenger</v-subheader>
                        </v-flex>
                        <v-flex xs8>
                          <v-text-field single-line @click.stop v-model="filter.messenger"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="clearSearch()">Clear Filter</v-btn>
                    <v-btn color="blue" class="text-white" @click="fetchPickedOut()">Search</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 v-if="onLoadding == false && pickedout.length == 0">
            <v-card>
              <v-card-text class="text-xs-center">
                <v-icon color="orange" x-large>error</v-icon>
                <h2>ไม่พบรายการพัสดุที่นำไปส่ง</h2>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 v-for="(parcel, index) in pickedout" :key="index">
            <v-card >
              <v-layout row wrap>
                <!-- <v-flex xs12 md2 @click="touchpicture(parcel)" pa-2> -->
                <!-- <v-img @click="touchpicture(parcel)"
                    src="static/noimage2.svg"
                    height="125px"
                    contain
                ></v-img>-->
                <!-- <ParcelDropImage :image_guid="parcel.image_guid"></ParcelDropImage> -->
                <!-- </v-flex> -->
                <v-flex xs12 md10 pa-2>
                  <h2>{{ parcel.cust_name }} ({{ parcel.ref_doc_no }})</h2>
                  <p>{{ parcel.address }}</p>
                  <p>{{ parcel.parcel_guid_list }}</p>
                </v-flex>
                <v-flex xs12 md2 text-xs-right class="item_center" pa-2>
                  <v-btn flat icon color="green darken-1" @click="touchpicture(parcel)">
                    <v-icon>check_circle</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 v-if="onLoadding" text-xs-center pa-4>
            <v-progress-circular indeterminate color="amber"></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>

    <v-dialog
      v-model="confirm_send_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="confirm_send_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>ยืนยันใบทัวร์</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="approve(selectedParcel);">
              <v-icon left color="light-green lighten-3">check_circle</v-icon>อนุมัติ
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <h2>{{ selectedParcel.cust_name }} ({{ selectedParcel.parcel_guid }})</h2>
          <p>{{ selectedParcel.address }}</p>
          <p>{{ selectedParcel.ref_doc_no }}</p>
        </v-card-text>
        <v-card-text>
          <!-- <v-img
                              src="static/noimage2.svg"                   
                              contain
                              height="80vh"
                    
          ></v-img>-->
          <ParcelDropImage v-if="confirm_send_dialog" :image_guid="selectedParcel.image_guid"></ParcelDropImage>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="error" @click="reject(selectedParcel);">ปฏิเสธ</v-btn>
          <v-spacer></v-spacer>
          <v-btn block color="success" @click="approve(selectedParcel);">อนุมัติ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PackShipService from "@/services/PackShipService";
import authen from "@/store/modules/authen";
import ParcelDropImage from "@/components/media/ParcelDropImage";

export default {
  name: "dropimageconfirm",
  metaInfo: {
    title: "Drop Image Confirm"
  },
  components: {
    // VWidget,
    // MiniStatistic,
    // VCircle,
    // ProfileCard,
    // CircleStatistic,
    // LinearStatistic,
    // BoxChart
    ParcelDropImage
  },
  data: () => ({
    onLoadding: false,

    pickedout: [],
    confirm_send_dialog: false,
    selectedParcel: {
      cust_name: "",
      parcel_guid: "",
      address: "",
      ref_doc_no: "",
      image_guid: ""
    },
    filter: {
      searchText: "",
      date: "",
      messenger: "",
      page: 1,
      rows: 20,
    }
  }),
  computed: {
    selected_parcel() {
      if (this.pickedout.length == 0) return "";

      let result =
        this.pickedout.filter(x => x.checked).length +
        "/" +
        this.pickedout.length;

      return result;
    }
  },
  methods: {
    ...mapActions("app", ["setTitleText"]),
    async fetchPickedOut() {
     

      this.onLoadding = true;
      //let pickedoutpage = [];
      await PackShipService.feachDropticketconfirm(this.filter)
        .then(res => {
          // console.log(res)
          if (res.success) {
            let pickedoutpage = this.mergeParcel(res.parcels);
            pickedoutpage.forEach(pick => {
              this.pickedout.push(pick);
            });
          }
          this.onLoadding = false;
          this.filter.page++
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
          this.onLoadding = false;
        });
    },
    mergeParcel(parcels) {
      let result = [];

      parcels.forEach(parcel => {
        let findAddr = result.find(obj => obj.ref_doc_no == parcel.ref_doc_no);
        if (findAddr) {
          // console.log(findAddr.ref_doc_no + " : " + parcel.ref_doc_no);
          findAddr.boxs++;
          findAddr.list_roworder =
            findAddr.list_roworder + "," + parcel.roworder.toString();
          findAddr.parcel_guid_list =
            findAddr.parcel_guid_list + "," + parcel.parcel_guid;
        } else {
          parcel.boxs = 1;
          parcel.list_roworder = "" + parcel.roworder.toString();
          parcel.parcel_guid_list = "" + parcel.parcel_guid;
          result.push(parcel);
        }
      });
      return result;
    },
    selectAll() {
      this.pickedout.forEach(parcel => {
        parcel.checked = true;
      });
    },
    selectNone() {
      this.pickedout.forEach(parcel => {
        parcel.checked = false;
      });
    },
    async submitPickParcel() {
      // pack
      let parcelsSelected = [];
      this.pickedout.forEach(parcel => {
        if (parcel.checked) {
          parcelsSelected.push(parcel.parcel_guid);
        }
      });

      await PackShipService.submitPickoutConfirm(parcelsSelected)
        .then(res => {
          if (res.data.success) {
            this.fetchPickedOut();
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    async pickoutCancel(parcelID) {
      await PackShipService.submitPickedOutCancel(parcelID)
        .then(res => {
          if (res.data.success) {
            // console.log(parcelID + "Cancel Success ");
            this.fetchPickedOut();
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    touchpicture(parcel) {
      // console.log(parcel)
      this.selectedParcel = parcel;
      this.confirm_send_dialog = true;
    },
    async reject(parcel) {
      //console.log("Reject : " + parcel.image_guid + "," + parcel.list_roworder)

      await PackShipService.rejectTicker(
        parcel.image_guid,
        parcel.list_roworder
      )
        .then(res => {
          // remove selected
          if (res.success) {
            let findAddr = this.pickedout.find(
              obj => obj.ref_doc_no == parcel.ref_doc_no
            );
            this.pickedout.splice(findAddr, 1);
            this.pickedout = [...this.pickedout];
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
      this.confirm_send_dialog = false;
    },
    async approve(parcel) {
      await PackShipService.approveTicker(
        authen.state.userCode,
        parcel.list_roworder
      )
        .then(res => {
          if (res.success) {
            // remove selected
            let findAddr = this.pickedout.find(
              obj => obj.ref_doc_no == parcel.ref_doc_no
            );
            this.pickedout.splice(findAddr, 1);
            this.pickedout = [...this.pickedout];
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
      this.confirm_send_dialog = false;
      //console.log("Approve : ")
    },
    async searchFilter() {
      await this.fetchPickedOut();
    },
    async clearSearch() {
      this.filter.date = null;
      this.filter.messenger = "";
      this.filter.searchText = "";
      this.filter.page = 1;
      await this.fetchPickedOut();
    }
  },
  mounted() {},
  created() {
    this.fetchPickedOut();
     window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          // Do something, anything!          
          this.fetchPickedOut()
          // console.log("do load more");
        }
      };
  }
};
</script>
<style scoped>
.item_center {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
</style>